<bic-popup (close)="onClose()" [customClass]="'w-[640px]'" [title]="'Prüflauf duplizieren'">
  <div bicPopupContent class="flex flex-col gap-4">
    <p class="text-sm text-gray-900">
      „{{ checkName }}" wird als eigener Prüflauf in dieses Projekt kopiert. Wählen Sie, ob die
      zugeordneten myChecks mitkopiert werden sollen.
    </p>

    <div class="flex flex-col gap-3">
      <label
        (click)="chooseMode('run-only')"
        class="flex flex-row items-center gap-3 rounded-lg border p-3 cursor-pointer hover:border-green"
        [class.border-green]="mode === 'run-only'"
        [class.border-gray-200]="mode !== 'run-only'">
        <input [checked]="mode === 'run-only'"
               [disabled]="saving"
               class="h-4 w-4 shrink-0 border-gray-300 text-green accent-green focus:ring-green"
               name="duplicate-mode"
               type="radio"/>
        <span class="flex flex-col">
          <span class="text-sm font-medium text-gray-900">Nur den Prüflauf</span>
          <span class="text-xs text-gray-500">
            Das Duplikat verwendet weiter die von der BIC bereitgestellten myChecks. Es ist sofort
            startklar, die Prüfregeln selbst bleiben aber schreibgeschützt.
          </span>
        </span>
      </label>

      <label
        (click)="chooseMode('run-and-rules')"
        class="flex flex-row items-center gap-3 rounded-lg border p-3"
        [class.border-green]="mode === 'run-and-rules'"
        [class.border-gray-200]="mode !== 'run-and-rules'"
        [class.cursor-pointer]="rulesOptionAvailable"
        [class.hover:border-green]="rulesOptionAvailable"
        [class.opacity-50]="!rulesOptionAvailable"
        [class.cursor-not-allowed]="!rulesOptionAvailable">
        <input [checked]="mode === 'run-and-rules'"
               [disabled]="saving || !rulesOptionAvailable"
               class="h-4 w-4 shrink-0 border-gray-300 text-green accent-green focus:ring-green"
               name="duplicate-mode"
               type="radio"/>
        <span class="flex flex-col">
          <span class="text-sm font-medium text-gray-900">Prüflauf und Prüfregeln</span>
          <span class="text-xs text-gray-500">
            Die gewählten myChecks werden als eigene Kopien im Projekt angelegt und im Duplikat
            verlinkt. Erst dann lassen sich die Prüfregeln anpassen.
          </span>
        </span>
      </label>
    </div>

    @if (loading) {
      <div class="flex flex-row items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-sm"></fa-icon>
        <span class="text-xs text-gray-500">Zugeordnete myChecks werden geladen...</span>
      </div>
    } @else if (loadFailed) {
      <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
        <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
        <span class="text-xs font-medium text-yellow-900">
          Die zugeordneten myChecks konnten nicht gelesen werden. Der Prüflauf lässt sich trotzdem
          duplizieren – die Prüfregeln bleiben dann die bereitgestellten.
        </span>
      </div>
    } @else if (!hasRulesets) {
      <p class="text-xs text-gray-500">
        Diesem Prüflauf sind keine myChecks fest zugeordnet – die Prüfregeln werden erst beim
        Ausführen gewählt. Es gibt daher nichts mitzukopieren.
      </p>
    } @else if (mode === 'run-and-rules') {
      <div class="flex flex-col gap-2">
        <div class="flex items-center justify-between gap-4">
          <span class="text-xs font-medium text-gray-500">
            {{ selected.size }} von {{ rulesets.length }} myChecks werden kopiert
          </span>
          <button (click)="toggleAll()"
                  [disabled]="saving"
                  class="text-sm font-medium text-green hover:underline disabled:opacity-50"
                  type="button">
            {{ allSelected ? 'Alle abwählen' : 'Alle auswählen' }}
          </button>
        </div>
        <div class="flex max-h-[280px] flex-col gap-2 overflow-y-auto">
          @for (entry of rulesets; track entry.ruleset.id) {
            <label
              class="flex cursor-pointer flex-row items-center gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2.5 hover:border-green">
              <input (change)="toggle(entry.ruleset.id)"
                     [checked]="isSelected(entry.ruleset.id)"
                     [disabled]="saving"
                     class="h-4 w-4 shrink-0 rounded border-gray-300 text-green accent-green focus:ring-green"
                     type="checkbox"/>
              <span class="flex min-w-0 flex-1 flex-col">
                <span class="truncate text-sm font-medium text-gray-900">{{ entry.ruleset.name }}</span>
                @if (entry.partial) {
                  <span class="text-xs text-gray-500">Nur einzelne Prüfregeln dieses myChecks sind zugeordnet</span>
                }
              </span>
              <bic-badge [bgClass]="typeConfig[entry.ruleset.type].bgClass"
                         [textClass]="typeConfig[entry.ruleset.type].textClass"
                         class="shrink-0">
                {{ typeConfig[entry.ruleset.type].label }}
              </bic-badge>
            </label>
          }
        </div>
      </div>
    }
  </div>

  <div bicPopupButtonGroup class="flex w-full flex-row items-center justify-end gap-4">
    <bic-button (onClick)="onClose()" [disabled]="saving" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="onConfirm()" [disabled]="confirmDisabled" [loading]="saving">Duplizieren</bic-button>
  </div>
</bic-popup>
